// Client-facing pages live on a Power Ray address (e.g. proposals.powerrayllc.com). When the app is served from a host
// that is not GridForge's own, only the public routes render and nothing says GridForge.
export function isPublicHost() {
  try {
    const here = window.location.hostname.toLowerCase();
    const gf = new URL(process.env.REACT_APP_BACKEND_URL).hostname.toLowerCase();
    if (!here || here === gf || here === "localhost" || here === "127.0.0.1") return false;
    return !/emergentagent\.com$/.test(here);
  } catch { return false; }
}

// Title + favicon for a client-facing page: the client's or Power Ray's, never GridForge's.
export function brandDocument(company, logo) {
  document.title = `${company || "Power Ray LLC"} · Proposal`;
  const desc = document.querySelector('meta[name="description"]');
  if (desc) desc.setAttribute("content", `${company || "Power Ray LLC"} — proposal`);
  const links = document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]');
  const href = logo || "data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect width="32" height="32" rx="6" fill="#003E87"/><circle cx="16" cy="16" r="7" fill="#F4C400"/></svg>');
  links.forEach((l) => { l.setAttribute("href", href); if (l.getAttribute("type")) l.removeAttribute("type"); });
  if (!links.length) { const l = document.createElement("link"); l.rel = "icon"; l.href = href; document.head.appendChild(l); }
}
